import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Data } from '@angular/router';
import { filter } from 'rxjs';

@Component({
	selector: 'app-breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {
	barra = '/';
	public breadcrumbs: IBreadCrumb[];

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute
	) {
		this.breadcrumbs = this._buildBreadcrumbs(this.activatedRoute.root);
	}

	ngOnInit() {
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(() => {
				this.breadcrumbs = this._buildBreadcrumbs(this.activatedRoute.root);
			});
	}
	private _buildBreadcrumbs(
		activatedRoute: ActivatedRoute,
		url = ''
	): IBreadCrumb[] {
		const children: ActivatedRoute[] = activatedRoute.children;
		if (children.length === 0) {
			return [];
		}
		let breadcrumbs: IBreadCrumb[] = [];
		for (const child of children) {
			const routeURL: string = child.snapshot.url
				.map(segment => segment.path)
				.join('');
			if (routeURL !== '') {
				url += `/${routeURL}`;
			}
			const routeData: Data = child.snapshot.data;
			if (routeData['breadcrumb']) {
				breadcrumbs.push({ label: routeData['breadcrumb'], url: url });
			}
			breadcrumbs = breadcrumbs.concat(this._buildBreadcrumbs(child, url));
		}
		return breadcrumbs;
	}
}
export interface IBreadCrumb {
	label: string;
	url: string;
}
